import React from "react";

import { forms } from "src/modules/kd/forms";
import { FormRenderer as FormRendererBare } from "src/modules/shared/form-renderer";

export const FormRenderer: React.FunctionComponent = () => {
	return <FormRendererBare forms={forms} />;
};
